import { ReactNode, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { AlertColor } from '@mui/material/Alert';
import { myUseState } from "~/hooks/myUseState";

export type TNotifyColors = AlertColor;

interface IState {
	showNotification: boolean;
}

interface INotify {
	children: ReactNode;
	open: boolean;
	type?: TNotifyColors;
	onClose?: () => void;
}

export default function Notify({
	children = null,
	open = false,
	type = "success",
	onClose = () => {},
}: INotify) {
	const { state, updateState } = myUseState<IState>({
		showNotification: false,
	});

	function closeNotification() {
		updateState({
			showNotification: false,
		});
		onClose();
	}

	function snackBarClose(event, closeType: string) {
		// type: timeout|clickaway
		if (closeType === "timeout") {
			closeNotification();
		}
	}

	useEffect(() => {
		updateState({
			showNotification: open,
		});
	}, [open]);

	return <Snackbar open={state.showNotification} autoHideDuration={6000} onClose={snackBarClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
		<Alert onClose={closeNotification} severity={type} sx={{ width: "100%" }} variant="filled">
			{ children }
		</Alert>
	</Snackbar>;
}
